const sandboxToolLabels: Readonly<Record<string, string>> = {
  exec_command: "Running a command",
  write_stdin: "Continuing a command",
  view_image: "Viewing an image",
  apply_patch: "Editing a file",
  import_file: "Importing a file",
  export_file: "Preparing a file",
};

export function sandboxToolLabel(identity: unknown): string | undefined {
  if (typeof identity !== "string") return undefined;
  for (const name of identity.toLowerCase().split(/[.\s]+/)) {
    if (Object.prototype.hasOwnProperty.call(sandboxToolLabels, name))
      return sandboxToolLabels[name];
  }
  return undefined;
}
